import { InMemoryCache } from '@apollo/client';
import fragmentIntrospection from 'Generated/fragmentIntrospection.generated';
import typePolicies from './typePolicies';

const createInMemoryCache = () =>
  new InMemoryCache({
    typePolicies,
    possibleTypes: fragmentIntrospection.possibleTypes,
  });

export default createInMemoryCache;
